import React from "react";
import { firstFeatureContent, secondFeatureContent, thirdFeatureContent } from "../../../utils/features";
import FeatureContent from "../../feature-content/FeatureContent";
import "./feature.css";

function MobileFeatureSection() {
  return (
    <section className="flex flex-col">
        <div className="feature-wrapper">
            <FeatureContent feature={firstFeatureContent} />
        </div>
        <div className="feature-reversed ">
            <FeatureContent feature={secondFeatureContent} />
        </div>
        <div className="feature-wrapper">
            <FeatureContent feature={thirdFeatureContent} />
        </div>
    </section>
  );
}

export default MobileFeatureSection;
